(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-accessibility-repairs"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const syncSlides = (root) => {
      if (root.matches?.('.slick-slide[aria-hidden]')) root.inert = root.getAttribute('aria-hidden') === 'true';
      root.querySelectorAll?.('.slick-slide[aria-hidden]').forEach(slide => {
        slide.inert = slide.getAttribute('aria-hidden') === 'true';
      });
    };
    syncSlides(document);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') syncSlides(record.target);
        else record.addedNodes.forEach(syncSlides);
      }
    }).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden']});

    const drawer = document.getElementById('halo-cart-sidebar');
    if (!drawer) return;
    const close = drawer.querySelector('[data-close-cart-sidebar]');
    const status = document.getElementById('lb-cart-status');
    const inerted = new Set();
    let opened = false;
    let suspended = false;
    let opener = null;
    let lastFocus = null;
    let lastControl = null;
    let pendingControl = null;
    const visible = element => Boolean(element?.isConnected && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert]'));
    const controls = () => [...drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')].filter(element => element.tabIndex >= 0 && !element.disabled && visible(element));
    const release = () => {
      inerted.forEach(element => { element.inert = false; });
      inerted.clear();
    };
    const isolate = () => {
      let current = drawer;
      while (current.parentElement) {
        for (const sibling of current.parentElement.children) {
          if (sibling !== current && !sibling.inert && !sibling.matches('script, style, link, .background-overlay')) {
            sibling.inert = true;
            inerted.add(sibling);
          }
        }
        current = current.parentElement;
        if (current === document.body) break;
      }
    };
    const focusFirst = () => (controls()[0] || drawer).focus({preventScroll: true});
    const focusOnOpen = () => {
      let frames = 0;
      const ready = () => {
        if (!opened || suspended) return;
        if (visible(close)) close.focus({preventScroll: true});
        else if (++frames < 90) requestAnimationFrame(ready);
      };
      requestAnimationFrame(ready);
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest?.('[data-cart-sidebar], [data-btn-addtocart]');
      if (trigger && !drawer.contains(trigger)) opener = trigger;
    }, true);
    const rememberUpdate = event => {
      const target = event.target.closest?.('.plus, .minus, [data-cart-quantity], [data-cart-remove]');
      if (!target || !drawer.contains(target)) return;
      const row = target.closest('.previewCartItem');
      const quantity = row?.querySelector('[data-cart-quantity]');
      if (!quantity) return;
      if (event.type === 'change' && pendingControl?.element.isConnected && pendingControl.line === quantity.dataset.line) return;
      pendingControl = {
        element: target,
        line: quantity.dataset.line,
        index: [...drawer.querySelectorAll('.previewCartItem')].indexOf(row),
        selector: target.matches('.plus') ? '.plus' : target.matches('.minus') ? '.minus' : target.matches('[data-cart-remove]') ? '[data-cart-remove]' : '[data-cart-quantity]'
      };
    };
    drawer.addEventListener('click', rememberUpdate, true);
    drawer.addEventListener('change', rememberUpdate, true);
    document.addEventListener('pointerdown', event => {
      if (pendingControl && event.target !== pendingControl.element) pendingControl = null;
    }, true);
    document.addEventListener('focusin', event => {
      if (!opened || suspended) return;
      if (!drawer.contains(event.target)) {
        focusFirst();
        return;
      }
      lastFocus = event.target;
      const quantity = event.target.closest('quantity-input, cart-quantity, .previewCartItem')?.querySelector('[data-cart-quantity]');
      lastControl = {id: event.target.id, line: quantity?.dataset.line, kind: event.target.matches('.plus') ? 'plus' : event.target.matches('.minus') ? 'minus' : 'input'};
    });
    const syncDrawer = () => {
      const nowOpen = document.body.classList.contains('cart-sidebar-show');
      const nested = ['quickshop-popup-show', 'quick_shop_popup_mobile', 'edit-cart-show', 'term-condition-show', 'has-warning'].some(name => document.body.classList.contains(name));
      if (nowOpen && !opened) {
        if (!visible(opener)) opener = document.activeElement;
        opened = true;
        drawer.inert = false;
        suspended = nested;
        if (!nested) {
          isolate();
          focusOnOpen();
        }
      } else if (!nowOpen && opened) {
        opened = false;
        release();
        if (visible(opener)) opener.focus({preventScroll: true});
        drawer.inert = true;
        lastFocus = null;
        lastControl = null;
        pendingControl = null;
      } else if (opened && suspended !== nested) {
        suspended = nested;
        if (nested) release();
        else {
          requestAnimationFrame(() => {
            if (!opened || suspended) return;
            isolate();
            if (visible(lastFocus)) lastFocus.focus({preventScroll: true});
            else focusOnOpen();
          });
        }
      }
    };
    new MutationObserver(syncDrawer).observe(document.body, {attributes: true, attributeFilter: ['class']});
    document.addEventListener('keydown', event => {
      if (!opened || suspended) return;
      if (event.key === 'Tab' || event.key === 'Escape') pendingControl = null;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        close.click();
      } else if (event.key === 'Tab') {
        const elements = controls();
        const first = elements[0] || drawer;
        const last = elements[elements.length - 1] || drawer;
        if (!drawer.contains(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last) || !elements.length) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }
    }, true);
    const content = drawer.querySelector('.previewCart-wrapper');
    const syncCartCount = () => {
      const label = drawer.querySelector('.wrapper-cartCount')?.textContent.replace(/\s+/g, ' ').trim();
      if (!label) return;
      document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach(element => {
        if (element.textContent !== label) element.textContent = label;
      });
    };
    new MutationObserver(syncCartCount).observe(drawer.querySelector('.wrapper-cartCount'), {childList: true, subtree: true, characterData: true});
    syncCartCount();
    if (content) new MutationObserver(() => {
      syncCartCount();
      if (!opened || suspended) return;
      if (pendingControl && !pendingControl.element.isConnected) {
        const pending = pendingControl;
        const rows = [...content.querySelectorAll('.previewCartItem')];
        const row = rows.find(item => item.querySelector('[data-cart-quantity]')?.dataset.line === pending.line) || rows[Math.min(pending.index, rows.length - 1)];
        const replacement = row?.querySelector(pending.selector) || content.querySelector('.button-continue') || close;
        pendingControl = null;
        requestAnimationFrame(() => {
          if (opened && !suspended && visible(replacement)) replacement.focus({preventScroll: true});
        });
      }
      if (lastFocus && !lastFocus.isConnected) {
        const sameId = lastControl?.id ? document.getElementById(lastControl.id) : null;
        const quantity = [...content.querySelectorAll('[data-cart-quantity]')].find(input => input.dataset.line === lastControl?.line);
        const replacement = sameId || (lastControl?.kind === 'input' ? quantity : quantity?.parentElement.querySelector('.' + lastControl?.kind));
        if (visible(replacement)) replacement.focus({preventScroll: true});
        else if (!drawer.contains(document.activeElement)) focusFirst();
      }
      if (status && !content.querySelector('.loading-overlay')) {
        const count = drawer.querySelector('.wrapper-cartCount')?.textContent.trim();
        const total = [...content.querySelectorAll('.previewCartTotals')].filter(visible).map(element => element.textContent.replace(/\s+/g, ' ').trim()).join('. ');
        const text = [count, total].filter(Boolean).join('. ');
        if (status.textContent !== text) status.textContent = text;
      }
    }).observe(content, {childList: true, subtree: true});
    syncDrawer();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lb-collection-dialog-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    if (!document.body.classList.contains('template-collection')) return;
    const mobile = matchMedia('(max-width: 1024px)');
    const configurations = [
      {panel: '#halo-sidebar', trigger: 'button.toolbar-sidebar[data-sidebar]', state: 'open-mobile-sidebar', close: '[data-close-sidebar]'},
      {panel: '[data-sorting][data-mobile="mobile"]', trigger: '[data-toggle][data-mobile="mobile"]', state: 'toolbar-modal-open', close: '.close-mobile-modal'}
    ];
    const inerted = new Set();
    let active = null;
    let lastFocusId = '';
    let queued = false;
    const release = () => {
      inerted.forEach(element => { element.inert = false; });
      inerted.clear();
    };
    const visible = element => Boolean(element?.isConnected && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert]'));
    const controls = panel => [...panel.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')]
      .filter(element => element.tabIndex >= 0 && !element.disabled && visible(element));
    const isolate = panel => {
      let current = panel;
      while (current.parentElement) {
        for (const sibling of current.parentElement.children) {
          if (sibling !== current && !sibling.inert && !sibling.matches('script,style,link,.background-overlay')) {
            sibling.inert = true;
            inerted.add(sibling);
          }
        }
        current = current.parentElement;
        if (current === document.body) break;
      }
    };
    const focusFirst = () => {
      if (!active) return;
      const close = active.panel.querySelector(active.config.close);
      (visible(close) ? close : controls(active.panel)[0] || active.panel).focus({preventScroll: true});
    };
    const focusOnOpen = () => {
      const openedPanel = active?.panel;
      let frames = 0;
      const ready = () => {
        if (!active || active.panel !== openedPanel) return;
        focusFirst();
        if (!active.panel.contains(document.activeElement) && ++frames < 90) requestAnimationFrame(ready);
      };
      requestAnimationFrame(ready);
    };
    const sync = () => {
      queued = false;
      const entries = configurations.map(config => ({config, panel: document.querySelector(config.panel), trigger: document.querySelector(config.trigger)}))
        .filter(entry => entry.panel && entry.trigger);
      const next = mobile.matches ? entries.find(entry => document.body.classList.contains(entry.config.state)) : null;
      if (active && active.panel !== next?.panel) {
        const previous = active;
        active = null;
        release();
        previous.panel.removeAttribute('role');
        previous.panel.removeAttribute('aria-modal');
        previous.panel.removeAttribute('aria-label');
        previous.panel.removeAttribute('tabindex');
        if (!next && mobile.matches) document.querySelector(previous.config.trigger)?.focus({preventScroll: true});
      }
      entries.forEach(entry => {
        const opened = entry.panel === next?.panel;
        entry.panel.inert = mobile.matches && !opened;
        if (entry.trigger.getAttribute('aria-expanded') !== String(opened)) entry.trigger.setAttribute('aria-expanded', String(opened));
      });
      if (!next) return;
      const newlyOpened = !active;
      active = next;
      active.panel.setAttribute('role', 'dialog');
      active.panel.setAttribute('aria-modal', 'true');
      active.panel.setAttribute('aria-label', active.trigger.textContent.trim());
      active.panel.setAttribute('tabindex', '-1');
      isolate(active.panel);
      if (newlyOpened) {
        lastFocusId = '';
        focusOnOpen();
      } else if (!active.panel.contains(document.activeElement)) {
        const replacement = lastFocusId ? document.getElementById(lastFocusId) : null;
        if (replacement && active.panel.contains(replacement) && visible(replacement)) replacement.focus({preventScroll: true});
        else focusFirst();
      }
    };
    const schedule = () => {
      if (!queued) { queued = true; requestAnimationFrame(sync); }
    };
    document.addEventListener('focusin', event => {
      if (!active) return;
      if (active.panel.contains(event.target)) lastFocusId = event.target.id;
      else focusFirst();
    });
    document.addEventListener('keydown', event => {
      if (!active) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        document.body.classList.remove(active.config.state);
        sync();
      } else if (event.key === 'Tab') {
        const items = controls(active.panel);
        const first = items[0] || active.panel;
        const last = items[items.length - 1] || active.panel;
        if (!items.length || !active.panel.contains(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }
    }, true);
    mobile.addEventListener('change', () => {
      if (!mobile.matches) configurations.forEach(config => document.body.classList.remove(config.state));
      sync();
    });
    new MutationObserver(schedule).observe(document.body, {attributes: true, attributeFilter: ['class']});
    new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded']});
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-swatch"] && !Shopify.designMode) return;
  try {
    (function () {
  function syncSwatch(button) {
    button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
  }
  function init(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root.matches && root.matches('.card-swatch button.swatch-label')) syncSwatch(root);
    root.querySelectorAll('.card-swatch button.swatch-label').forEach(syncSwatch);
  }
  init(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes' && record.target.matches('.card-swatch button.swatch-label')) {
        syncSwatch(record.target);
      } else if (record.type === 'childList') {
        record.addedNodes.forEach(init);
      }
    });
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
})();
  } catch(e) { console.error(e); }
})();

})();
